import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import DashboardHeader from '../shared/components/DashboardHeader';
import SideMenu from '../shared/components/SideMenu';
import Footer from '../shared/components/Footer';
import HttpCall from '../api/Http';
import SerializeClass from '../shared/Utils/serialized';
import User from '../shared/Utils/User'
import axios from 'axios';
import Alert from '../shared/Utils/AlertBox';
import Loader from '../shared/components/Loader';
import Moment from 'react-moment';

export default function Invoice() {

  const user = User.getUser()

  const [userSubscription, setUserSubscription] = useState([]);

  useEffect(() => {
    getUserSubscriptions();
  }, [])

  const getUserSubscriptions = () => {
    let arr = [];
    arr.push({ P_user_id: user[0].Id });
    let p = SerializeClass.getSerializedData(arr);
    let header = {
      headers: { 'Authorization': `Token ${user[0].token}` }
    };

    let url = `https://api.getbound.ai/api/user/getUserSubscritionList?Params=${p}`;
    axios.get(url, header).then(response => {
      console.log(response);
      if (response.data.code == 200) {
        setUserSubscription(response.data.data);
      } else {
        Alert.show("Error!", response.data.msg, "error");
      }
    }).catch(err => {
      console.log(err);
    })
  }

  function downloadInvoice(id) {
    let arr = [];
    arr.push({ P_user_id: user[0].Id });
    arr.push({ P_Id: id });

    let p = SerializeClass.getSerializedData(arr);

    // let header = {
    //   headers: { 'Authorization': `Token ${user[0].token}` }
    // };
    let url = `https://api.getbound.ai/api/generic/downloadInvoice?Params=${btoa(p)}`;
    // fileDownload(url, 'filename.pdf');

    // saveAs(
    //   url,
    //   "example.pdf",
    // );
    window.open(url, "_blank")
    // var link = document.createElement('a');
    // link.href = url;
    // link.download = "Report_" + new Date() + ".pdf";
    // link.click();
    // axios.get(url).then(response => {
    //   downloadFile(response.data, 'filename.pdf');
    // }).catch(err => {
    //   console.log(err);
    // })
  }

  function downloadFile(res) {
    var blob = new Blob([res], { type: "application/pdf" });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = "Report_" + new Date() + ".pdf";
    link.click();
  }



  return (
    <>
      <DashboardHeader />
      <div className="container-fluid page-body-wrapper">
        <SideMenu />
        <div class="main-panel">
          <div class="content-wrapper">
            <div class="row">

              <div class="col-md-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-9">
                        <h4 class="card-title">Invoices</h4>
                        <p class="card-description">
                          Note: Invoices list
                        </p>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Subscription</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>PDF</th>
                          </tr>
                        </thead>
                        <tbody>
                          {userSubscription.length > 0 && userSubscription.map((data, index) => (<tr key={index}>
                            <td>{index + 1}</td>
                            <td><Moment format="DD-MM-YYYY">{data.start_date}</Moment></td>
                            <td><Moment format="DD-MM-YYYY">{data.end_date}</Moment></td>
                            <td>{data.plan_name}</td>
                            <td>
                              ${data.price.toFixed(2)}</td>
                            <td>{data.is_active}</td>
                            <td>
                              <button type="button" class="btn btn-md">
                                <i onClick={() => { downloadInvoice(data.id) }} class="ti-download"></i>
                              </button>
                            </td>
                          </tr>))}
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>
              </div>





            </div>
          </div>


          <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">

              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Copyright © 2023 <a href="http://getbound.ai/">Getbound.ai</a> - All rights reserved</span>
            </div>
          </footer>

        </div>


      </div>
    </>
  )
}